import React from "react";
import * as c from "./lpCompetitorSection.module.scss";
import classNames from "classnames";
import MangomintLogo from "@images/competitors/mangomint.svg";
import StaticGradient from "@components/shared/staticGradient";
import { useScrolltriggerClassnames } from "@hooks/useScrolltriggerClassnames";
import competitorData from "./competitorData";

export default function LpCompetitorSection({ slug }) {
  useScrolltriggerClassnames();

  const data = competitorData[slug];
  if (!data) return null;

  const { pageHeader, competitor, rows } = data;
  const hasComparison = rows.some((row) => row.col3);

  return (
    <section className={c.container}>
      <StaticGradient
        top="0%"
        mask="linear-gradient(to bottom, transparent 12.5%, #000, transparent)"
        height="100%"
        opacity="0.45"
      />
      <div className={c.textContainer} data-transition="slide-enter-child">
        <h1 className="h1">{pageHeader.heading}</h1>
        <p className={"p2"}>{pageHeader.subheading}</p>
      </div>

      <div className={classNames(c.cardContainer, { [c.singleColumn]: !hasComparison })} data-transition="slide-enter">
        <div className={c.row}>
          <div className={classNames(c.col1, c.col)}></div>
          <div className={classNames(c.col2, c.col)}>
            <img className={c.logo} src={MangomintLogo} alt="Mangomint Logo" />
          </div>
          {/* Only show competitor logo if we have comparison columns */}
          {hasComparison && (
            <div className={classNames(c.col3, c.col)}>
              <div className={classNames(c.logo, c.secondaryLogo)}>
                <img
                  // Add height modifiers to allow tweaking logo heights for visual consistency
                  style={{ "--heightModifier": competitor.height ? competitor.height : "0px" }}
                  className={c.secondaryLogoImage}
                  src={competitor.logo}
                  alt={`${competitor.name} Logo`}
                />
              </div>
            </div>
          )}
        </div>

        {rows.map(({ col1, col2, col3 }, i) => (
          <div key={`${competitor.name}-${col1}`} className={c.row}>
            <div className={classNames(c.col1, c.col)}>
              <p className={classNames(c.label, "eyebrow")} dangerouslySetInnerHTML={{ __html: col1 }}></p>
            </div>
            <div className={classNames(c.col2, c.col)}>
              <h2 className={i === 0 ? "h5" : "p3"} dangerouslySetInnerHTML={{ __html: col2 }}></h2>
            </div>
            {col3 && (
              <div className={classNames(c.col3, c.col)}>
                <h2 className={i === 0 ? "h5" : "p3"} dangerouslySetInnerHTML={{ __html: col3 }}></h2>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className={c.arrowContainer} data-transition="addclass">
        <p className={classNames(c.label, "eyebrow")}>
          <span>Find out more</span>
        </p>
        <svg xmlns="http://www.w3.org/2000/svg" width={61} height={65} viewBox="0 0 61 65" fill="none">
          <path
            d="M60 8.09542C50.5352 36.5782 22.8048 38.3479 11.4117 32.2254C-3.49961 22.7699 0.018607 9.58054 7.05553 3.77398C14.0925 -2.03257 28.1438 1.25241 34.8681 13.8577C41.5924 26.4631 40.5408 48.8994 40.5408 63.3052"
            stroke="#474F7B"
            strokeWidth={2}
            strokeLinecap="round"
          />
          <path
            d="M47.5778 52.1406C43.2216 56.8225 41.5461 63.9999 40.7395 63.9999C39.9328 63.9999 35.5145 56.4624 30.4881 53.2211"
            stroke="#474F7B"
            strokeWidth={2}
            strokeLinecap="round"
          />
        </svg>
      </div>
    </section>
  );
}
